import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { memo, useMemo } from 'react';
import { __OPERATION__EVENT__ADMIN__ } from 'shell/constants/environment';
import { ItemVM } from 'shell/view-models/item';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponseList } from 'shell/models/http-response';
import { Subscriber } from 'shell/models/subscriber';
import { AxiosResponse } from 'axios';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { PmiSelect } from 'shell/components/shared/pmi-select';

interface SubscriberListComponentProps {
  disabled?: boolean;
  required?: boolean;
  value: string;
  onChange: (event: SelectChangeEvent<string>) => void;
  onBlur?: () => void;
  error?: boolean;
}

const SubscriberListComponent = ({
  disabled,
  onChange,
  onBlur = () => {
    return;
  },
  value,
  error,
  required,
}: SubscriberListComponentProps): React.ReactElement => {
  const [subscribers] = useHttpFetch<HttpResponseList<Subscriber>, Array<ItemVM>>(
    `${__OPERATION__EVENT__ADMIN__}/sottoscrittore/list`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
        data: {},
      },
      transformer: (response: AxiosResponse<HttpResponseList<Subscriber>>) => {
        const data = response.data.payload?.list || [];
        const list = data.map((item: Subscriber) => ({
          id: item?.codice,
          value: item?.descrizione,
        }));

        return list;
      },
    }
  );

  const subscribersList = useMemo(() => {
    const data = (subscribers.data as Array<ItemVM>) || [];
    const res = data.sort((a, b) => {
      if (a.id > b.id) return 1;
      if (a.id < b.id) return -1;
      return 0;
    });
    return res;
  }, [subscribers]);

  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id="subscriber-label">
        {required ? 'Sottoscrittore *' : 'Sottoscrittore'}
      </InputLabel>
      <PmiSelect
        labelId="subscriberCode-label"
        id="subscriberCode"
        name="subscriberCode"
        value={value}
        label={required ? 'Sottoscrittore *' : 'Sottoscrittore'}
        onChange={onChange}
        disabled={disabled}
        error={error}
        onBlur={onBlur}
      >
        <MenuItem value="">
          <em>nessuno</em>
        </MenuItem>
        {subscribersList
          ? subscribersList?.map((item: ItemVM) => (
              <MenuItem key={item.id} value={item.id}>
                {item.value}
              </MenuItem>
            ))
          : undefined}
      </PmiSelect>
    </PmiFormControl>
  );
};

SubscriberListComponent.displayName = 'Subscriber item component';

const SubscribertList = memo(SubscriberListComponent);

export default SubscribertList as typeof SubscriberListComponent;
